module.exports = __webpack_public_path__ + "img/logo.13635aa8.png";